<template>
  <div>
    <!-- 顶部按钮栏 -->
    <mtd-row>
      <mtd-col :span="12" class="height-full">
        <span class="page-title-32">{{ $getText('wenshu_web_download_history', '下载记录') }}</span>
      </mtd-col>
      <mtd-col :span="12"
               class="height-full text-right">
        <div class="batch-buttons" v-if="hasSelectedFiles">
          <mtd-button icon="mtdicon mtdicon-download-o" @click="handle_batch_download()">
            {{ $getText('wenshu_mobile_download', '下载') }}
          </mtd-button>
          <mtd-button icon="mtdicon mtdicon-delete-o" @click="handle_batch_delete()">
            {{ $getText('wenshu_web_delete', '删除') }}
          </mtd-button>
        </div>
      </mtd-col>
    </mtd-row>
    <!-- 快速搜索栏 -->
    <div class="action-header" style="margin-top:16px;">
      <div class="left">
        <div class="search">
          <mtd-input :placeholder="$getText('wenshu_web_quick_search', '快速检索')" style="width: 330px;" v-model="keyword">
            <template slot="append">
              <i class="mtdicon mtdicon-search" @click="load_file_list()"></i>
            </template>
          </mtd-input>
        </div>
      </div>
      <div class="right">
        <div style="margin-top:10px;">
          <span class="blue">
            <mtd-icon name="info-circle-o"/>
          </span>
          <span>{{ $getText('ws_mobile_file_count_unit', {count: selectedFiles.length}), '{count}个文件' }}</span>
        </div>
      </div>
    </div>
    <!-- 表格 -->
    <div class="table-container" style="margin-top:16px;">
      <mtd-table size="small" :data="file_list" :selection="selectedFiles" :empty-text="$getText('wenshu_web_no_data', '暂无数据')">
        <mtd-table-column type="selection" width="44">
          <div slot-scope='scope'>
            <mtd-checkbox v-bind='scope.props' v-on='scope.on'/>
          </div>
        </mtd-table-column>
        <mtd-table-column prop="s3FileName" :label="$getText('wenshu_mobile_file_name', '文件名称')" show-overflow-tooltip/>
        <mtd-table-column prop="fileSize" :label="$getText('wenshu_web_file_size', '文件大小')" width="200">
          <div slot-scope='scope'>
            <span>{{ scope.row.fileSize | formatFileSize }}</span>
          </div>
        </mtd-table-column>
        <mtd-table-column prop="createTime" :label="$getText('wenshu_web_upload_time', '上传时间')" width="180">
          <div slot-scope="scope">
            <span>{{ scope.row.createTime | dateTimeFormat }}</span>
          </div>
        </mtd-table-column>
        <mtd-table-column prop="expirationTime" :label="$getText('wenshu_web_expiration_time', '过期时间')" width="180">
          <div slot-scope="scope">
            <span>{{ scope.row.expirationTime * 1000 | dateTimeFormat }}</span>
          </div>
        </mtd-table-column>
        <mtd-table-column fixed="right" :label="$getText('wenshu_web_operation', '操作')" width="160">
          <template slot-scope="scope">
            <!--不限制权限或者已经通过，则直接放行下载-->
            <mtd-button @click="handleCryptboxDownload(scope.row.id)" type="text-primary" size="small"
                        class="operate-btns" :disabled="scope.row.fileExpired"
                        style="padding-left: 0;">
              <span v-if="scope.row.fileExpired">{{ $getText('wenshu_web_expired', '已过期') }}</span>
              <span v-else style="width: 36px;display: inline-block;">{{ $getText('wenshu_mobile_download', '下载') }}</span>
            </mtd-button>
            <mtd-button @click="handleDeleteFile(scope.row.id)" type="text-primary" size="small" class="operate-btns"
                        style="padding-right: 0;">
              {{ $getText('wenshu_web_delete', '删除') }}
            </mtd-button>
          </template>
        </mtd-table-column>
      </mtd-table>
      <div class="pagination-block">
        <mtd-pagination size="small" style="text-align: right;margin-top: 12px" :total="pagination.total"
                        :page-size="pagination.limit" :current-page.sync="pagination.currentPage"
                        @change="load_file_list()"/>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment/moment";
  import {mapActions} from "vuex";
  import {map} from 'lodash'

  export default {
    name: "file_mine_list",
    filters: {
      dateTimeFormat(dateTime) {
        return moment(dateTime)
          .utcOffset(480)
          .format('YYYY-MM-DD HH:mm:ss');
      },
      // 格式化文件大小
      formatFileSize(size) {
        const file_size_reg = /^\d+$/;
        if (!file_size_reg.test(size)) {
          return size;
        }
        //如果字节数少于1024，则直接以B为单位，否则先除于1024，后3位因太少无意义
        if (size < 1024) {
          return size + 'B'
        } else {
          size = size / 1024
        }
        //如果原字节数除于1024之后，少于1024，则可以直接以KB作为单位
        //因为还没有到达要使用另一个单位的时候
        //接下去以此类推
        if (size < 1024) {
          return size.toFixed(2) + 'KB'
        } else {
          size = size / 1024
        }
        if (size < 1024) {
          //因为如果以MB为单位的话，要保留最后1位小数，
          //因此，把此数乘以100之后再取余
          return size.toFixed(2) + 'MB'
        } else {
          size = size / 1024
        }
        if (size < 1024) {
          //因为如果以MB为单位的话，要保留最后1位小数，
          //因此，把此数乘以100之后再取余
          return size.toFixed(2) + 'GB'
        } else {
          size = size / 1024
          return size.toFixed(2) + 'TB'
        }
      }
    },
    data() {
      return {
        keyword: null,
        file_list: [],
        pagination: {
          total: 0,
          limit: 10,
          offset: 1,
          currentPage: 1
        },
        selectedFiles: []
      }
    },
    computed: {
      hasSelectedFiles() {
        return this.selectedFiles.length > 0
      }
    },
    mounted() {
      this.load_file_list();
    },
    methods: {
      ...mapActions([
        'api_file_mine_query_list',
        'api_file_mine_delete',
        'api_file_mine_generate_url'
      ]),
      load_file_list() {
        const search_param = {
          ...this.pagination,
          total: undefined,
          fileName: this.keyword,
          isDel: 0
        };
        this.api_file_mine_query_list(search_param).then(res => {
          const data = res.data;
          const {items, total} = data;
          this.file_list = items;
          this.pagination.total = total;
        })
      },
      handleCryptboxDownload(fileId) {
        if (!fileId) {
          return
        }
        // 获取文件下载链接
        this.api_file_mine_generate_url({id: fileId, no_need_cancel: true}).then((res) => {
          let url = res.data;
          if (url) {
            if (window.secDBDownload) {
              window.secDBDownload.downloadFile(url);
            } else {
              window.open(url, '_blank')
            }
          }
        });
      },
      // 删除文件
      async handleDeleteFile(fileId) {
        if (!fileId) {
          return;
        }
        const params = {
          idList: [fileId]
        }
        this.$mtd.confirm({
          title: this.$getText('wenshu_web_confirm_delete_file', '确定要删除该文件吗？'),
          message: this.$getText('wenshu_web_file_deletion_irreversible', '文件删除之后无法恢复'),
          width: '430px',
          showCancelButton: true,
          type: 'error',
          cancelButtonText: this.$getText('wenshu_web_cancel', '取消'),
          okButtonText: this.$getText('wenshu_web_delete', '删除'),
          okButtonProps: {
            type: 'danger',
          },
          onOk: () => {
            this.api_file_mine_delete(params).then(() => {
              this.load_file_list();
            });
          }
        });
      },
      handle_batch_download() {
        let idList = map(this.selectedFiles, (f) => {
          if (!f.fileExpired) {
            return f.id;
          }
        });
        idList.forEach(async (id) => {
          await this.handleCryptboxDownload(id)
        })
      },
      // 删除文件
      async handle_batch_delete() {
        const params = {
          idList: map(this.selectedFiles, (f) => f.id)
        }

        this.$mtd.confirm({
          title: this.$getText('wenshu_web_confirm_delete_file', '确定要删除该文件吗？'),
          message: this.$getText('wenshu_web_file_deletion_irreversible', '文件删除之后无法恢复'),
          width: '430px',
          showCancelButton: true,
          type: 'error',
          cancelButtonText: this.$getText('wenshu_web_cancel', '取消'),
          okButtonText: this.$getText('wenshu_web_delete', '删除'),
          okButtonProps: {
            type: 'danger',
          },
          onOk: () => {
            this.api_file_mine_delete(params).then(() => {
              this.load_file_list();
            });
          }
        });
      }
    }
  }
</script>

<style>
  @import "../../styles/reset_table.css";

  .action-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .batch-buttons {
    display: inline;
  }

  .batch-buttons .mtd-btn {
    margin-right: 8px;
  }

  .mtd-table-cell button.operate-btns {
    color: #0a70f5;
    border: none;
    height: 20px;
    line-height: 20px;
  }
</style>
